import type { ChangeEvent } from 'react';
import { useTranslation } from 'utils/i18n';
import Textbox from '../../textbox';

interface Props {
  value: string;
  // The first validation message for the field, or undefined when valid.
  error?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const AddressLineOneField = ({ error, ...props }: Props) => {
  const { t } = useTranslation();

  return (
    <Textbox
      label={t('registration.company_details.fields.address1.label')}
      name="address1"
      placeholder={t('registration.company_details.fields.address1.label')}
      error={!!error}
      errorMsg={error}
      className="input--address-line-one"
      {...props}
    />
  );
};

export default AddressLineOneField;
